import React from "react";

export const DistributerDetailsContext = React.createContext();